import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTopImmediate = () => {
      // 1. Lenis instant scroll to top
      if (typeof window !== "undefined" && window.__lenis) {
        window.__lenis.scrollTo(0, { immediate: true });
      }

      // 2. Native window and document scroll reset
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      // 3. Recalculate GSAP ScrollTrigger positions from top
      ScrollTrigger.refresh();
    };

    // Execute immediately on route change
    scrollToTopImmediate();

    // Execute again on next frame and after page transition exit completes
    const rafId = requestAnimationFrame(scrollToTopImmediate);
    const timeout1 = setTimeout(scrollToTopImmediate, 50);
    const timeout2 = setTimeout(scrollToTopImmediate, 350);

    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, [pathname]);

  return null;
}
